<template lang="pug">
.study-detail
  //- サイドメニュー部
  side-menu.study-detail__side-menu(
    :userRole='userRole',
    :currentLink='currentLink',
    :linkEvent='sideMenuLinkEvent',
    :logoutEvent='logoutEvent'
  )
    template(#separateText)
      slot(name='sideMenuSeparateText')
    template(#logoutText)
      slot(name='logoutText')
  //- コンテンツ表示部
  .study-detail__content
    breadcrumb-list.study-detail__content__breadcrumb(
      :breadcrumbs='breadcrumbs',
      :moveEvent='breadcrumbMoveEvent',
      :buttonEvent='breadcrumbButtonEvent'
    )
      template(#buttonLabel)
        slot(name='breadcrumbButtonLabel')
    .study-detail__content__body
      .study-detail__content__body__heading
        tab-heading.study-detail__content__body__heading__tab(
          :isActive='isTabActive(tabSetting.LAST_MINUTE_CHECK)',
          @click='tabHeadingEvent(tabSetting.LAST_MINUTE_CHECK.value)'
        ) {{ tabSetting.LAST_MINUTE_CHECK.text }}
        tab-heading.study-detail__content__body__heading__tab(
          :isActive='isTabActive(tabSetting.RESOLVE)',
          @click='tabHeadingEvent(tabSetting.RESOLVE.value)'
        ) {{ tabSetting.RESOLVE.text }}
      .study-detail__content__body__main
        study-detail-table.study-detail__content__body__main__table(
          v-if='sort && studyDetails',
          :sort='sort',
          :sortChangeEvent='changeSort',
          :studyDetails='studyDetails',
          :numberSelectOptions='numberSelectOptions',
          :endConditionSelectOptions='endConditionSelectOptions'
        )
          template(#subjectHeader)
            slot(name='subjectHeader')
          template(#selectionHeader)
            slot(name='selectionHeader')
          template(#numberHeader)
            slot(name='numberHeader')
          template(#endConditionHeader)
            slot(name='endConditionHeader')
          template(#periodStartDateHeader)
            slot(name='periodStartDateHeader')
          template(#periodEndDateHeader)
            slot(name='periodEndDateHeader')
          template(#registrationDateHeader)
            slot(name='registrationDateHeader')
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator'
import SideMenu from '@/components/organisms/manager/SideMenu.vue'
import BreadcrumbList from '@/components/organisms/manager/BreadcrumbList.vue'
import TabHeading from '@/components/molecules/manager/TabHeading.vue'
import StudyDetailTable from '@/components/organisms/manager/StudyDetailTable.vue'
import { breadcrumbType } from '@/models/breadcrumbModel'
import { InputItem } from '@/models/inputItem'
import { StudyDetailType, StudyDetailSortType } from '@/models/studyDetailModel'
import { LinkSetting } from '@/const/SideMenuSettings'
import { UserRoles } from '@/const/UserRoles'
import { SUnitCategorySetting } from '@/const/ApiSettings'
import { StudyDetailTabSetting, TabLinkSetting } from '@/const/TabLinkSettings'
import { SortSetting } from '@/const/SortSettings'

/**
 * テスト詳細画面
 */
@Component({
  components: {
    SideMenu,
    BreadcrumbList,
    TabHeading,
    StudyDetailTable,
  },
})
export default class StudyDetail extends Vue {
  // ユーザ権限
  @Prop()
  userRole!: UserRoles

  // このページのリンク設定
  @Prop()
  currentLink!: LinkSetting

  // サイドメニューリンク押下時のイベント
  @Prop()
  sideMenuLinkEvent!: Function

  // ログアウトボタン押下時のイベント
  @Prop()
  logoutEvent!: Function

  // パンくず一覧情報
  @Prop()
  breadcrumbs!: breadcrumbType[]

  // パンくず遷移イベント
  @Prop()
  breadcrumbMoveEvent!: Function

  // パンくず内ボタン押下時イベント
  @Prop()
  breadcrumbButtonEvent!: Function

  // 小項目区分
  @Prop()
  category!: SUnitCategorySetting

  // ソート値（項目毎の昇順フラグ）
  @Prop()
  sort!: StudyDetailSortType

  // テスト詳細表示情報
  @Prop()
  studyDetails!: StudyDetailType[]

  // 回数選択オプション
  @Prop()
  numberSelectOptions!: InputItem[]

  // 条件選択オプション
  @Prop()
  endConditionSelectOptions!: InputItem[]

  // 見出しタブクリック時のイベント
  @Prop()
  tabHeadingEvent!: Function

  // ソート値を変更
  private changeSort(sortSetting: SortSetting, sortTarget: string) {
    const sort = this.sort
    sort[sortTarget] = sortSetting
    this.$emit('sort-changed', sort)
  }

  // 見出しタブのアクティブ判定
  private isTabActive(tab: TabLinkSetting) {
    return String(this.category) === tab.value
  }

  // 見出しタブリンクの表示設定
  private get tabSetting(): StudyDetailTabSetting {
    return StudyDetailTabSetting
  }
}
</script>

<style lang="stylus" scoped>
.study-detail
  display flex
  width 100%
  height 100%

  &__content
    width 100%
    height 100%
    display flex
    flex-direction column
    padding 40px
    gap 20px
    overflow-y auto

    &__body
      display flex
      flex-direction column

      &__heading
        display flex
        height 43px

      &__main
        z-index 1
        width 100%
        min-height 500px
        display flex
        flex-direction column
        border-radius 0px 15px 15px 15px
        background var(--color-manager-list__background)
        box-shadow 0px 3px 5px 0px var(--color-manager-list__shadow)

        &__table
          margin-top 20px
</style>
